/**
 * ResponsiveModal Component
 * Renders BottomSheet on mobile (<640px) and Modal on desktop.
 * Use this for modals that need better mobile UX with single scrollable view.
 */

import React from 'react';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import Modal from './Modal';
import BottomSheet from './BottomSheet';

const ResponsiveModal = ({
  isOpen,
  onClose,
  title,
  children,
  size = 'md',        // Modal size for desktop (sm, md, lg, xl)
  maxHeight = '85vh'  // BottomSheet max height for mobile
}) => {
  const isMobile = useMediaQuery('(max-width: 639px)');

  if (isMobile) {
    return (
      <BottomSheet
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        maxHeight={maxHeight}
      >
        {children}
      </BottomSheet>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size={size}
    >
      {children}
    </Modal>
  );
};

export default ResponsiveModal;
